// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "disturbance-frontend/js/" + chunkId + "." + "7469bd8820a9ba319892" + ".bundle.js";
};